// extracted by mini-css-extract-plugin
export default {"photosWrapper":"styles_photosWrapper__KIOHD","photosBody":"styles_photosBody__4LJ7-","trash":"styles_trash__WZKVO","photosEmpty":"styles_photosEmpty__MC7Rr"};